/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import axios from 'axios';
import {useTranslation} from "react-i18next";

const useAxios = () =>{

    const { t, i18n } = useTranslation();
    const baseURL = `${process.env.REACT_APP_URL}${i18n.language}`;

    const _axios = axios.create({
        baseURL,
        //headers: { 'Content-Type': 'application/json' },
        //withCredentials: true
    });

    _axios.interceptors.request.use( (config) => {
        // Do something before request is sent
        //console.log(config);
        return config;
    },  (error) => {
        // Do something with request error
        //console.log(error);
        return Promise.reject(error);
    });


    _axios.interceptors.response.use( (response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        //console.log(response);
        return response;
    },  (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        //console.log(error);
        return Promise.reject(error);
    });

    return _axios;

}

export default useAxios;

